import React from 'react';
import styled from 'styled-components';

import { getSrc } from '../../../../../../../utils/common/getSrc';

type TProps = {
    readonly src: string;
    readonly edit?: boolean;
};
export const VideoView: React.FC<TProps> = props => {
    const { src, edit } = props;

    return (
        <StyledVideo autoPlay={false} controls={true}>
            <source src={getSrc(edit ? src : `/storage/${src}`)} />
        </StyledVideo>
    );
};

const StyledVideo = styled.video`
    width: 100%;
`;
